import { useState, useEffect } from "react";

export const CookieNotice = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem("cd_cookie_ok")) setShow(true);
  }, []);
  if (!show) return null;
  return (
    <div data-testid="cookie-notice"
         className="fixed bottom-4 inset-x-4 md:left-auto md:right-6 md:max-w-md z-[60] bg-navy text-white p-6 shadow-2xl border-l-4 border-orange">
      <p className="text-sm leading-relaxed text-white/80">
        We use cookies to improve your experience and analyze site traffic. By continuing to browse,
        you agree to our use of cookies in line with Canadian privacy practices.
      </p>
      <div className="flex gap-3 mt-4">
        <button data-testid="cookie-accept"
                onClick={() => { localStorage.setItem("cd_cookie_ok", "1"); setShow(false); }}
                className="btn-orange px-4 py-2 text-xs font-semibold uppercase tracking-wide">Accept</button>
        <button data-testid="cookie-decline"
                onClick={() => setShow(false)}
                className="px-4 py-2 text-xs font-semibold uppercase tracking-wide border border-white/30 hover:border-white transition-colors">
          Decline
        </button>
      </div>
    </div>
  );
};
